

// import React, { useEffect, useState, useRef } from 'react';
// import './formreport.css';
// import axios from 'axios';
// import html2pdf from 'html2pdf.js';

// const TeaCollectionReport = () => {
//   const [farmers, setFarmers] = useState([]);
//   const [selectedFarmer, setSelectedFarmer] = useState('');
//   const [reportType, setReportType] = useState('daily');
//   const [fromDate, setFromDate] = useState('');
//   const [toDate, setToDate] = useState('');
//   const [reportData, setReportData] = useState([]);

//   const [farmerQuery, setFarmerQuery] = useState('');
//   const [showFarmerDropdown, setShowFarmerDropdown] = useState(false);
//   const dropdownRef = useRef(null);

//   const filteredFarmers = farmers.filter(f =>
//     f.name.toLowerCase().includes(farmerQuery.toLowerCase()) ||
//     f.farmid.toLowerCase().includes(farmerQuery.toLowerCase())
//   );

//   useEffect(() => {
//     axios.get('https://kmtea.onrender.com/farmers')
//       .then(res => setFarmers(res.data))
//       .catch(err => console.error('Failed to load farmers:', err));
//   }, []);

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
//         setShowFarmerDropdown(false);
//       }
//     };
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   const handleFarmerSelect = (farmer) => {
//     setSelectedFarmer(farmer.farmid);
//     setFarmerQuery(`${farmer.name} (${farmer.farmid})`);
//     setShowFarmerDropdown(false);
//   };

//   const formatDate = (dateStr) => new Date(dateStr).toLocaleDateString('en-GB');
//   const formatTime = (dateStr) => {
//     const date = new Date(dateStr);
//     return date.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
//   };

//   const getWeekName = (date) => {
//     const monthName = date.toLocaleString('default', { month: 'short' });
//     const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
//     const weekNumber = Math.ceil((date.getDate() + firstDay.getDay()) / 7);
//     const suffix = ['1st', '2nd', '3rd', '4th', '5th'][weekNumber - 1] || `${weekNumber}th`;
//     return `${monthName} - ${suffix} Week`;
//   };

//   // const getGroupKey = (itemDate) => {
//   //   const date = new Date(itemDate);
//   //   if (reportType === 'daily') {
//   //     return date.toLocaleDateString('en-GB');
//   //   } else if (reportType === 'weekly') {
//   //     return getWeekName(date);
//   //   } else if (reportType === 'monthly') {
//   //     return `${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear()}`;
//   //   }
//   //   return '';
//   // };
// const getGroupKey = (itemDate) => {
//   const date = new Date(itemDate);

//   if (reportType === 'daily') {
//     return date.toLocaleDateString('en-GB');
//   }

//   if (reportType === 'weekly') {
//     const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
//     const dayOfMonth = date.getDate();
//     const weekOfMonth = Math.ceil((dayOfMonth + firstDayOfMonth.getDay()) / 7);
//     const monthName = date.toLocaleString('default', { month: 'short' });
//     return `Week ${weekOfMonth} - ${monthName} ${date.getFullYear()}`;
//   }

//   if (reportType === 'monthly') {
//     return `${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear()}`;
//   }

//   return '';
// };

//   const fetchReport = async () => {
//     try {
//       const res = await axios.get('https://kmtea.onrender.com/collecttea');
//       let data = res.data;

//       const now = new Date();
//       const start = fromDate ? new Date(fromDate) : new Date(now.getFullYear(), now.getMonth(), 1);
//       const end = toDate ? new Date(toDate) : new Date(now.getFullYear(), now.getMonth() + 1, 0);

//       if (reportType === 'daily' && !fromDate && !toDate) {
//         start.setDate(1);
//         end.setMonth(start.getMonth() + 1, 0);
//       }

//       // Filter date range
//       data = data.filter(item => {
//         const itemDate = new Date(item.date);
//         return itemDate >= start && itemDate <= end;
//       });

//       // Filter by farmer if selected
//       if (selectedFarmer) {
//         data = data.filter(item => item.farmid === selectedFarmer);
//       }

//       // Grouping logic
//       const groupData = (dataArr) => {
//         const grouped = {};
//         dataArr.forEach(item => {
//           const key = getGroupKey(item.date);
//           if (!grouped[key]) {
//             grouped[key] = {
//               date: key,
//               qty: 0,
//               tare: 0,
//               netweight: 0,
//               water: 0,
//               stick: 0,
//               count: 0
//             };
//           }
//           grouped[key].qty += parseFloat(item.qty || 0);
//           grouped[key].tare += parseFloat(item.tare || 0);
//           grouped[key].netweight += parseFloat(item.netweight || 0);
//           grouped[key].water += parseFloat(item.water || 0);
//           grouped[key].stick += parseFloat(item.stick || 0);
//           grouped[key].count += 1;
//         });

//         return Object.keys(grouped).map(k => ({
//           ...grouped[k],
//           avgNetWeight: (grouped[k].netweight / grouped[k].count).toFixed(2)
//         }));
//       };

//       if (reportType === 'daily' && selectedFarmer) {
//         // For daily single farmer: raw entries
//         setReportData(data.sort((a, b) => new Date(a.date) - new Date(b.date)));
//       } else {
//         // Grouped data for all others
//         setReportData(groupData(data));
//       }

//     } catch (err) {
//       console.error('Error fetching report:', err);
//     }
//   };

//   const handleDownload = () => {
//     const el = document.querySelector('.farmer-report__table-container');
//     html2pdf().set({
//       margin: 0.5,
//       filename: 'TeaCollectionReport.pdf',
//       image: { type: 'jpeg', quality: 0.98 },
//       html2canvas: { scale: 2 },
//       jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' }
//     }).from(el).save();
//   };

//   return (
//     <div className="farmer-report__container">
//       <h2>Tea Collection Report</h2>

//       <div className="farmer-report__filters">
//         <div className="input-group">
//           <div className="farmer-selector-wrapper" ref={dropdownRef}>
//             <label>Farmer</label>
//             <input
//               type="text"
//               placeholder="Select farmer..."
//               value={farmerQuery}
//               onChange={(e) => {
//                 setFarmerQuery(e.target.value);
//                 setShowFarmerDropdown(true);
//               }}
//               onFocus={() => setShowFarmerDropdown(true)}
//             />
//             {showFarmerDropdown && (
//               <ul className="dropdown">
//                 <li
//                   onClick={() => {
//                     setSelectedFarmer('');
//                     setFarmerQuery('All Farmers');
//                     setShowFarmerDropdown(false);
//                   }}
//                 >
//                   All Farmers
//                 </li>
//                 {filteredFarmers.map((farmer) => (
//                   <li key={farmer.farmid} onClick={() => handleFarmerSelect(farmer)}>
//                     {farmer.name} ({farmer.farmid})
//                   </li>
//                 ))}
//               </ul>
//             )}
//           </div>
//         </div>

//         <select value={reportType} onChange={e => setReportType(e.target.value)}>
//           <option value="daily">Daily</option>
//           <option value="weekly">Weekly</option>
//           <option value="monthly">Monthly</option>
//         </select>

//         <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} />
//         <input type="date" value={toDate} onChange={e => setToDate(e.target.value)} />

//         <button onClick={fetchReport}>Get Report</button>
//         <button onClick={handleDownload} style={{ backgroundColor: '#28a745' }}>Download</button>
//       </div>

//       {reportData.length > 0 ? (
//         <div className="farmer-report__table-container">
//           <table className="farmer-report__table">
//             <thead>
//               <tr>
//                 {reportType === 'daily' && selectedFarmer ? (
//                   <>
//                     <th>Date</th>
//                     <th>Time</th>
//                     <th>Farmer</th>
//                     <th>Qty</th>
//                     <th>Tare</th>
//                     <th>Net</th>
//                     <th>Water</th>
//                     <th>Stick</th>
//                     <th>Qty List</th>
//                   </>
//                 ) : (
//                   <>
//                     <th>{reportType.charAt(0).toUpperCase() + reportType.slice(1)}</th>
//                     <th>Farmer</th>
//                     <th>Total Qty</th>
//                     <th>Total Tare</th>
//                     <th>Total Net</th>
//                     <th>Total Water</th>
//                     <th>Total Stick</th>
//                     <th>Avg Net/Entry</th>
//                   </>
//                 )}
//               </tr>
//             </thead>
//             <tbody>
//               {reportData.map((item, i) => (
//                 <tr key={i}>
//                   {reportType === 'daily' && selectedFarmer ? (
//                     <>
//                       <td>{formatDate(item.date)}</td>
//                       <td>{formatTime(item.date)}</td>
//                       <td>{farmerQuery || 'Unknown'}</td>
//                       <td>{item.qty}</td>
//                       <td>{item.tare}</td>
//                       <td>{item.netweight}</td>
//                       <td>{item.water}</td>
//                       <td>{item.stick}</td>
//                       <td>
//                         {Array.isArray(item.qtyList)
//                           ? item.qtyList.join(', ')
//                           : typeof item.qtyList === 'string'
//                           ? (() => {
//                               try {
//                                 const parsed = JSON.parse(item.qtyList);
//                                 return Array.isArray(parsed) ? parsed.join(', ') : item.qtyList;
//                               } catch {
//                                 return item.qtyList;
//                               }
//                             })()
//                           : ''}
//                       </td>
//                     </>
//                   ) : (
//                     <>
//                       <td>{item.date}</td>
//                       <td>{selectedFarmer ? farmerQuery : 'All'}</td>
//                       <td>{item.qty.toFixed(2)}</td>
//                       <td>{item.tare.toFixed(2)}</td>
//                       <td>{item.netweight.toFixed(2)}</td>
//                       <td>{item.water.toFixed(2)}</td>
//                       <td>{item.stick.toFixed(2)}</td>
//                       <td>{item.avgNetWeight}</td>
//                     </>
//                   )}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       ) : (
//         <div className="farmer-report__no-data">No report data available.</div>
//       )}
//     </div>
//   );
// };

// export default TeaCollectionReport;


import React, { useEffect, useState, useRef } from 'react';
import './formreport.css';
import axios from 'axios';
import html2pdf from 'html2pdf.js';

const TeaCollectionReport = () => {
  const [farmers, setFarmers] = useState([]);
  const [selectedFarmer, setSelectedFarmer] = useState('');
  const [reportType, setReportType] = useState('daily');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [reportData, setReportData] = useState([]);

  const [farmerQuery, setFarmerQuery] = useState('');
  const [showFarmerDropdown, setShowFarmerDropdown] = useState(false);
  const dropdownRef = useRef(null);

  /* ===================== FARMERS ===================== */
  useEffect(() => {
    axios.get('https://kmtea.onrender.com/farmers')
      .then(res => setFarmers(res.data))
      .catch(err => console.error(err));
  }, []);

  const filteredFarmers = farmers.filter(f =>
    f.name.toLowerCase().includes(farmerQuery.toLowerCase()) ||
    f.farmid.toLowerCase().includes(farmerQuery.toLowerCase())
  );

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowFarmerDropdown(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleFarmerSelect = (farmer) => {
    setSelectedFarmer(farmer.farmid);
    setFarmerQuery(`${farmer.name} (${farmer.farmid})`);
    setShowFarmerDropdown(false);
  };

  /* ===================== HELPERS ===================== */
  const formatDate = (d) => new Date(d).toLocaleDateString('en-GB');
  const formatTime = (d) =>
    new Date(d).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });

  const getGroupKey = (itemDate) => {
    const date = new Date(itemDate);

    if (reportType === 'daily')
      return date.toLocaleDateString('en-GB');

    if (reportType === 'weekly') {
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      const week = Math.ceil((date.getDate() + firstDay.getDay()) / 7);
      return `Week ${week} - ${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear()}`;
    }

    return `${date.toLocaleString('default', { month: 'short' })} ${date.getFullYear()}`;
  };

  /* ===================== FETCH REPORT ===================== */
  const fetchReport = async () => {
    try {
      const res = await axios.get('https://kmtea.onrender.com/collecttea');
      let data = res.data;

      const now = new Date();
      const start = fromDate ? new Date(fromDate) : new Date(now.getFullYear(), now.getMonth(), 1);
      const end = toDate ? new Date(toDate) : new Date(now.getFullYear(), now.getMonth() + 1, 0);

      data = data.filter(i => {
        const d = new Date(i.date);
        return d >= start && d <= end;
      });

      if (selectedFarmer) {
        data = data.filter(i => i.farmid === selectedFarmer);
      }

      if (reportType === 'daily' && selectedFarmer) {
        setReportData(data.sort((a, b) => new Date(a.date) - new Date(b.date)));
        return;
      }

      const grouped = {};
      data.forEach(item => {
        const key = getGroupKey(item.date);
        if (!grouped[key]) {
          grouped[key] = { date: key, qty: 0, tare: 0, netweight: 0, water: 0, stick: 0, count: 0 };
        }
        grouped[key].qty += +item.qty || 0;
        grouped[key].tare += +item.tare || 0;
        grouped[key].netweight += +item.netweight || 0;
        grouped[key].water += +item.water || 0;
        grouped[key].stick += +item.stick || 0;
        grouped[key].count++;
      });

      setReportData(
        Object.values(grouped).map(g => ({
          ...g,
          avgNetWeight: (g.netweight / g.count).toFixed(2)
        }))
      );
    } catch (err) {
      console.error(err);
    }
  };

  /* ===================== GRAND TOTAL ===================== */
  const grandTotal = reportData.reduce(
    (t, i) => {
      t.qty += +i.qty || 0;
      t.tare += +i.tare || 0;
      t.net += +i.netweight || 0;
      t.water += +i.water || 0;
      t.stick += +i.stick || 0;
      return t;
    },
    { qty: 0, tare: 0, net: 0, water: 0, stick: 0 }
  );

  /* ===================== PDF ===================== */
  const handleDownload = () => {
    html2pdf().set({
      margin: 0.5,
      filename: 'TeaCollectionReport.pdf',
      html2canvas: { scale: 2 },
      jsPDF: { format: 'a4', orientation: 'landscape' }
    }).from(document.querySelector('.farmer-report__table-container')).save();
  };

  /* ===================== UI ===================== */
  return (
    <div className="farmer-report__container">
      <h2>Tea Collection Report</h2>

      <div className="farmer-report__filters">
        <div ref={dropdownRef}>
          <input
            placeholder="Select farmer..."
            value={farmerQuery}
            onChange={e => { setFarmerQuery(e.target.value); setShowFarmerDropdown(true); }}
          />
          {showFarmerDropdown && (
            <ul className="dropdown">
              <li onClick={() => { setSelectedFarmer(''); setFarmerQuery('All Farmers'); }}>All Farmers</li>
              {filteredFarmers.map(f => (
                <li key={f.farmid} onClick={() => handleFarmerSelect(f)}>{f.name} ({f.farmid})</li>
              ))}
            </ul>
          )}
        </div>

        <select value={reportType} onChange={e => setReportType(e.target.value)}>
          <option value="daily">Daily</option>
          <option value="weekly">Weekly</option>
          <option value="monthly">Monthly</option>
        </select>

        <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} />
        <input type="date" value={toDate} onChange={e => setToDate(e.target.value)} />

        <button onClick={fetchReport}>Get Report</button>
        <button onClick={handleDownload}>Download</button>
      </div>

      {reportData.length > 0 && (
        <div className="farmer-report__table-container">
          <table className="farmer-report__table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Farmer</th>
                <th>Qty</th>
                <th>Tare</th>
                <th>Net</th>
                <th>Water</th>
                <th>Stick</th>
                <th>Avg</th>
              </tr>
            </thead>

            <tbody>
              {reportData.map((i, idx) => (
                <tr key={idx}>
                  <td>{i.date}</td>
                  <td>{selectedFarmer ? farmerQuery : 'All'}</td>
                  <td>{i.qty.toFixed(2)}</td>
                  <td>{i.tare.toFixed(2)}</td>
                  <td>{i.netweight.toFixed(2)}</td>
                  <td>{i.water.toFixed(2)}</td>
                  <td>{i.stick.toFixed(2)}</td>
                  <td>{i.avgNetWeight}</td>
                </tr>
              ))}

              {/* ===== GRAND TOTAL ROW ===== */}
              <tr className="grand-total-row">
                <td colSpan="2"><strong>Grand Total</strong></td>
                <td><strong>{grandTotal.qty.toFixed(2)}</strong></td>
                <td><strong>{grandTotal.tare.toFixed(2)}</strong></td>
                <td><strong>{grandTotal.net.toFixed(2)}</strong></td>
                <td><strong>{grandTotal.water.toFixed(2)}</strong></td>
                <td><strong>{grandTotal.stick.toFixed(2)}</strong></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default TeaCollectionReport;
